import { StandardFeature } from '../standard/standard.feature';
import { Layer } from '@app/modules/cop/store/cop/models';
import { Dataset } from '@app/modules/core/store/models';
import { MarkerUrls } from '../feature.model';

interface MarkerImageProps {
  status: 'inactive' | 'active';
  color: string;
}

interface IsActiveFnArgs {
  layer?: Layer;
  dataset?: Dataset;
  document?: Document;
}

export const SELECTED_Z_INDEX = 10000;

export class CameraFeature extends StandardFeature {
  protected markerIconOptions = {
    size: new google.maps.Size(47, 47),
    anchor: new google.maps.Point(23.5, 40)
  };

  // * NOTE *  when extending this class, override this method to provide ot
  public isCameraActive(args: IsActiveFnArgs): boolean {
    return true;
  }

  private activeProps: MarkerImageProps = { status: 'active', color: '40C057' };
  private inactiveProps: MarkerImageProps = { status: 'inactive', color: 'C92A2A' };

  buildMarkerImageUrls(layer: Layer, dataset: Dataset, document: Document): MarkerUrls {
    const { status, color } = this.isCameraActive({ layer, dataset, document }) ? this.activeProps : this.inactiveProps;
    const imageName = `camera-${status}-pin`;

    return {
      normal: `/api/v1/meta/markers/${imageName}/${color}/0/0/normal/${imageName}.png`,
      selected: `/api/v1/meta/markers/${imageName}/${color}/0/0/selected/${imageName}.png`
    };
  }
}
